import React from 'react';
import clsx from 'clsx';

// Components
import Chip from '@mui/material/Chip';
import useStyles from './styles';

const ChipState = ({ state, label, ...rest }) => {
    const { classes } = useStyles();

    const classChip = clsx(classes.default, {
        [classes[state]]: !!classes[state]
    });

    return <Chip className={classChip} label={label} {...rest} />
} 

export default ChipState;